import Flag from 'react-world-flags';

export const getLanguageIcon = (selectedLanguage) => {
    switch (selectedLanguage) {
        case "en":
            return <Flag code="GB"
                         style={{
                             width: "28px",
                             height: "28px",
                             borderRadius: "50%",
                             objectFit: "cover"}}
                         alt="United States" />
        case "it":
            return <Flag code="IT"
                         style={{
                             width: "28px",
                             height: "28px",
                             borderRadius: "50%",
                             objectFit: "cover"}}
                         alt="Italy" />
        default:
            return <Flag code="GB"
                         style={{
                             width: "28px",
                             height: "28px",
                             borderRadius: "50%",
                             objectFit: "cover"}}
                         alt="United States" />
    }
}